import * as React from "react";
import MaskedInput, { MaskedInputProps } from "./MaskedInput";

interface CurrencyInputProps extends Omit<MaskedInputProps, "mask" | "unmask"> {
  integerLimit?: number;
  allowDecimal?: boolean;
  allowNegative?: boolean;
  leftAlignInput?: boolean;
  mask?: MaskedInputProps["mask"];
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  mask = Number,
  className,
  allowNegative,
  allowDecimal,
  integerLimit,
  leftAlignInput,
  ...rest
}) => {
  return (
    <MaskedInput
      {...rest}
      min={allowNegative ? Number.MIN_SAFE_INTEGER : 0}
      integerLimit={integerLimit}
      allowDecimal={allowDecimal}
      textAlign={!leftAlignInput ? "right" : undefined}
      className={className}
      thousandsSeparator=" "
      mask={mask}
    />
  );
};

export default CurrencyInput;
